import React from 'react';
import {
  Box,
  DialogTitle,
  IconButton,
  DialogContent as MuiDialogContent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { handleDialogClose } from './PinnacleDialog.helpers';
import StyledPinnacleDialog from './PinnacleDialog.styled';
import { PinnacleDialogProps } from './PinnacleDialog.types';
import { APP_SEARCH_BANNER_URL } from '../../utils/constants';

export const PinnacleDialog: React.FC<PinnacleDialogProps> = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  const {
    isOpen,
    setIsOpen,
    disableBackDropClick,
    renderShowAllVideosPerSubject,
    renderDefaultContent,
    renderTermsAndServices,
    includeBannerImg,
    headerTitle,
    persistKey,
    children,
    ...rest
  } = props;
  return (
    <StyledPinnacleDialog
      {...rest}
      open={!!isOpen}
      onClose={(_, reason: string) => {

        // Only used for search modal
        if (props.persistKey) {
          sessionStorage.setItem(props.persistKey, 'false');
          sessionStorage.setItem('lastSearchTerm', '');
        }
        if (setIsOpen) {
          handleDialogClose(reason, setIsOpen, disableBackDropClick ?? false);
        }
      }}
      scroll="paper"
      disableScrollLock
      slotProps={
        renderDefaultContent
          ? {
            paper: {
              sx: {
                width: '100%',
                maxWidth: '448px',
                m: 1,
              },
            },
          }
          : renderShowAllVideosPerSubject
            ? {
              paper: {
                sx: {
                  width: '100%',
                  maxWidth: '836px',
                  m: 1,
                },
              },
            }
            : renderTermsAndServices
              ? {
                paper: {
                  sx: {
                    width: '100%',
                    maxWidth: '800px',
                    m: 1,
                  },
                },
              }
              : undefined
      }
    >
      {renderShowAllVideosPerSubject && (
        <>
          {includeBannerImg && (
            <Box
              component="img"
              src={APP_SEARCH_BANNER_URL}
              alt="CPA Banner"
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                background: '#00080F'
              }}
            />

          )}
          <MuiDialogContent
            sx={{
              background: '#00080F',
              maxWidth: '836px'
            }}
          >

            <DialogTitle sx={{ p: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  pr: 1
                }}
              >
                <Typography variant='h5' sx={{ fontWeight: 700, pb: isMobile ? '16px' : 0, pt: isMobile ? '12px' : 0 }}>
                  {headerTitle}
                </Typography>

                <IconButton
                  aria-label="close"
                  onClick={() => setIsOpen?.(false)}
                  sx={{
                    color: (theme) => theme.palette.common.white,
                    position: 'absolute',
                    top: 25,
                    right: 25,
                    zIndex: 2,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>

            {/* Content */}
            {children}
          </MuiDialogContent>
        </>
      )}

      {(!renderShowAllVideosPerSubject && !renderDefaultContent && !renderTermsAndServices) && (
        <MuiDialogContent
          sx={{
            background: '#00080F',
          }}
        >
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={() => setIsOpen?.(false)}
            sx={{
              color: (theme) => theme.palette.common.white,
              position: 'absolute',
              top: 20,
              right: 25,
              zIndex: 2,
            }}
          >
            <CloseIcon style={{ fontSize: 30 }} />
          </IconButton>

          {/* Main Content */}
          {children}
        </MuiDialogContent>
      )}

      {renderDefaultContent && (
        <>
          <MuiDialogContent
            sx={{
              background: '#00080F'
            }}
          >
            <DialogTitle sx={{ p: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  pr: 1,
                  mb: 3
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  {headerTitle}
                </Typography>
                <IconButton
                  aria-label="close"
                  onClick={() => setIsOpen?.(false)}
                  sx={{
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            {children}
          </MuiDialogContent>
        </>
      )}

      {renderTermsAndServices && (
        <MuiDialogContent
          sx={{
            background: '#00080F',
            maxWidth: '800px',
            overflow: 'visible',
            padding: 0
          }}
        >
          {/* Header title */}
          <DialogTitle sx={{ p: 0 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                pr: 1,
                mb: 3,
              }}
            >
              <Typography variant="h3" sx={{ fontWeight: 700, pl: '20px' }}>
                {headerTitle}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={() => setIsOpen?.(false)}
                sx={{
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>

          {/* Terms content (scrollable Box) */}
          {children}

        </MuiDialogContent>
      )}

    </StyledPinnacleDialog>
  );
};

export default PinnacleDialog;
